import useConfig from './useConfig';

export default useConfig;
